module.exports = __webpack_public_path__ + "img/South African.b89e5026.svg";